<template>
  <div>
    <loading-block v-if="!loaded"></loading-block>
    <v-card v-else elevation="0">
      <v-card-title>
        <v-text-field
          prepend-icon="search"
          v-model="search"
          label="Search"
          single-line
          hide-details
          :footer-props="{
            'items-per-page-options': [10, 20, 40, -1]
          }"
        ></v-text-field>
      </v-card-title>

      <!-- <div class="text-center my-5">
      <v-pagination :total-visible="10" :circle="true" v-model="page" :length="pageCount"></v-pagination>
      </div>-->

      <v-data-table
        class="px-5 py-3tabulardata"
        :headers="headers"
        :items.sync="listItem"
        :page.sync="page"
        :items-per-page.sync="itemsPerPage"
        :search="search"
        @page-count="pageCount = $event"
        :custom-filter="customFilter"
      >
        <template v-slot:item.name="{ item }">
          <div class="inline-logo-name limited-img-height">
            <img
              v-if="item.image"
              style="width:60px; height:auto; max-height:60px; vertical-align:middle;"
              :src="item.image"
              :alt="item.name"
            />
            <span style="margin-left:20px;">{{ item.name }}</span>
          </div>
        </template>
        <template v-slot:item.category="{ item }">
          <div class>{{ getMasterProductCategoryNameFromId(item.category_id) }}</div>
        </template>
        <template v-slot:item.action="{ item }" width="200px">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="viewDetails(item)">
                <v-btn v-on="on" fab small dark color="primary" class="mr-2" depressed>
                  <v-icon dark>edit</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="deleteItem(item)">
                <v-btn v-on="on" fab small dark color="primary" class="mr-2" depressed>
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <p class="mb-0">No data.</p>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>

import { ProductAPI } from '@/clients/product/product.api'
import { CategoryAPI } from '@/clients/product/category.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { defaultFilter } from 'vuetify/lib/util/helpers'

export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      // search: '',
      // page: 1,
      // pageCount: 1,
      // itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name', sortable: true, width: 300 },
        { text: 'Description', value: 'description', sortable: true, search: false },
        { text: 'Category', value: 'category', sortable: true, search: false },
        { text: 'Actions', value: 'action', sortable: false, width: 150 }
      ],
      materProductCategoryList: [],
      listItem: []
    }
  },
  computed: {
    page: {
      get() {
        return this.vg_page
      },
      set(value) {
        this.setProductListPage(value)
      }
    },
    pageCount: {
      get() {
        return this.vg_productListPageCount
      },
      set(value) {
        this.setProductListPageCount(value)
      }
    },
    itemsPerPage: {
      get() {
        return this.vg_productListPerPage
      },
      set(value) {
        this.setProductListPerPage(value)
      }
    },
    search: {
      get() {
        return this.vg_productListSearch
      },
      set(value) {
        this.setProductListSearch(value)
      }
    },
    ...mapGetters({
      vg_page: 'product/productListPage',
      vg_productListPageCount: 'product/productListPageCount',
      vg_productListPerPage: 'product/productListPerPage',
      vg_productListSearch: 'product/productListSearch',
      addModal: 'product/addPop',
      editModal: 'product/editPop'
    })
  },
  async created() {
    try {
      this.loaded = false
      this.setEditPop(false)
      this.setAddPopup(false)
      await this.productList()
      this.loaded = true
    } catch (err) {
      console.log(err)
      this.loaded = true
    }
  },
  watch: {
    editModal(value) {
      if (value === false) {
        this.productList();
      }
    },
    addModal(value) {
      if (value === false) {
        this.productList();
      }
    }
  },
  methods: {
    customFilter(value, search, item) {
      if (search.toLocaleLowerCase() === 'no brand') {
        return item.brand_id === null
      } else {
        return defaultFilter(value, search, item)
      }
    },
    async productList() {
      try {
        const categoryData = await CategoryAPI.list()
        this.materProductCategoryList = categoryData.data.payload

        const productData = await ProductAPI.list()
        this.listItem = productData.data.payload
      } catch (err) {
        this.listItem = []
      }
    },
    /**
     * Get master product category name from id
     */
    getMasterProductCategoryNameFromId(id) {
      let catObj = _.find(this.materProductCategoryList, function (o) { return o.id === id })
      if (catObj !== undefined) {
        return catObj.name
      }
      return '--'
    },

    /**
     * Function accept object which has an id, return confirm then delete the category
     */
    deleteItem(obj) {
      document.activeElement.blur()
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete ${obj.name}.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function (result) {
        if (result.value) {
          self.spinner(true)
          let res = await ProductAPI.delete(obj.id)
          self.spinner(false)
          if (res.status === 200) {
            self.setSectionType('list')
            self.setActiveItem({})
            self.$swal(
              'Deleted!',
              `${obj.name} successfully deleted.`,
              'success'
            )
            await self.productList()
          } else {
            self.$swal(
              'Failed!',
              'Please try again later.',
              'error'
            )
          }
        }
      })
    },

    /**
     * Open Detail section
     */
    viewDetails(productObj) {
      this.setActiveItem(productObj)
      this.setSectionType('detail')
      this.editItem(productObj)
    },

    /**
     * Edit popup setup
     */
    editItem(obj) {
      this.setEditPop(true)
      this.setEditObj(obj)
    },

    ...mapActions({
      setProductListPage: 'product/setProductListPage',
      setProductListPageCount: 'product/setProductListPageCount',
      setProductListPerPage: 'product/setProductListPerPage',
      setProductListSearch: 'product/setProductListSearch',
      setAddPopup: 'product/setAddPop',
      setEditPop: 'product/setEditPop',
      setEditObj: 'product/setEditObj',
      setSectionType: 'product/setSectionType',
      setActiveItem: 'product/setActiveItem'
    })
  }
}
</script>
